import { Observable } from 'rxjs';

/**
 * @module ServicesService
 */
function createServicesService(apiService, paymentProcessorService, util) {
    const _servicesService = {};
    const subInfo = {};

    function updateSubInfo(newSubInfo) {
        util.clear(subInfo);
        util.merge(subInfo, newSubInfo);
    }

    // ****************************
    // public members
    // ****************************

    /**
     * @param {*} deviceId
     * @param {*} productId
     * @returns {Observable}
     * @name selectProductForSub
     * @method
     */
    _servicesService.selectProductForSub = function(deviceId, productId) {
        return new Observable(subscriber => {
            apiService.services.selectProductForSub({
                deviceId: deviceId,
                productId: productId
            }).then(
                result => {
                    subscriber.next(result.data);
                    subscriber.complete();
                },
                e => subscriber.error(e)
            );
        });
    };

    /**
     * @param {*} deviceId
     * @param {*} productType
     * @param {*} surveyData
     * @returns {Observable}
     * @name unselectTypeForSub
     * @method
     */
    _servicesService.unselectTypeForSub = function(deviceId, productType, surveyData) {
        return new Observable(subscriber => {
            apiService.services.unselectTypeForSub({
                deviceId: deviceId,
                productType: productType,
                surveyData: surveyData
            }).then(
                result => {
                    subscriber.next(result.data);
                    subscriber.complete();
                },
                e => subscriber.error(e)
            );
        });
    };

    /**
     * @returns {Observable}
     * @name getSubInfo
     * @method
     */
    _servicesService.getSubInfo = function() {
        return new Observable(subscriber => {
            paymentProcessorService.get(util.getTendPaymentProcessorId()).subscribe({
                next(paymentProcessorResult) {
                    apiService.services.getSubCurrent({
                        paymentProcessorId: paymentProcessorResult.id
                    }).then(
                        subscriptionResult => {
                            updateSubInfo(subscriptionResult.data);
                            subscriber.next(subInfo);
                            subscriber.complete();
                        },
                        e => {
                            updateSubInfo({});
                            subscriber.error(e);
                        }
                    );
                },
                error(e) {
                    subscriber.error(e);
                }
            });
        });
    };

    /**
     * @param {*} deviceId
     * @param {*} productId
     * @returns {Observable}
     * @name selectProduct
     * @method
     */
    _servicesService.selectProduct = function(deviceId, productId) {
        return new Observable(subscriber => {
            _servicesService.getSubInfo().subscribe({
                next() {
                    return apiService.services.selectProductForSub({
                        deviceId: deviceId,
                        productId: productId
                    }).then(
                        subscriptionResult => {
                            updateSubInfo(subscriptionResult.data);
                            subscriber.next(subInfo);
                            subscriber.complete();
                        },
                        () => {
                            updateSubInfo({});
                            subscriber.error(subInfo);
                        }
                    );
                },
                error() {
                    updateSubInfo({});
                    subscriber.error(subInfo);
                }
            });
        });
    };

    /**
     * @param {*} deviceId
     * @param {*} productType
     * @param {*} surveyData
     * @returns {Observable}
     * @name unselect
     * @method
     */
    _servicesService.unselect = function(deviceId, productType, surveyData) {
        return new Observable(subscriber => {
            _servicesService.getSubInfo().subscribe({
                next() {
                    return apiService.services.unselectTypeForSub({
                        deviceId: deviceId,
                        productType: productType,
                        surveyData: surveyData
                    }).then(
                        subscriptionResult => {
                            updateSubInfo(subscriptionResult.data);
                            subscriber.next(subInfo);
                            subscriber.complete();
                        },
                        () => {
                            updateSubInfo({});
                            subscriber.error(subInfo);
                        }
                    );
                },
                error() {
                    updateSubInfo({});
                    subscriber.error(subInfo);
                }
            });
        });
    };

    /**
     * @returns {Observable}
     * @name cancel
     * @method
     */
    _servicesService.cancel = function() {
        const vm = this;
        return new Observable(subscriber => {
            _servicesService.getSubInfo().subscribe({
                next() {
                    if (vm.subInfo
                            && vm.subInfo.currentSub
                            && vm.subInfo.currentSub.lines
                            && vm.subInfo.currentSub.lines.length > 0) {
                        const line = vm.subInfo.currentSub.lines[0];
                        apiService.services.unselectTypeForSub({
                            deviceId: line.deviceId,
                            productType: line.product.productType
                        }).then(
                            subscriptionResult => {
                                updateSubInfo(subscriptionResult.data);
                                _servicesService.cancel();
                            },
                            e => subscriber.error(e)
                        );
                    } else {
                        // TODO: finalize the cancellation
                        subscriber.next(subInfo);
                        subscriber.complete();
                    }
                }
            });
        });
    };

    return Object.freeze(_servicesService);
}

export default createServicesService;
